<template>
   <van-popup v-model="show"  position="bottom" :style="{ height: '310px' }">
       <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
        >
            <template slot="default">
                <div class="header">
                    <div @click="cancel">取消</div>
                    <div @click="confirm">确认</div>
                </div>
            </template>
        </van-datetime-picker>
   </van-popup>
</template>

<script>

export default {
    data() {
        return {
            show: false,
            minDate: new Date(),
            maxDate: new Date(2080, 10, 1),
            currentDate: new Date()
        }
    },

    methods: {
        open(obj) {
            if (obj.currentDate) {
                console.log()
                this.currentDate = obj.currentDate
            }
            this.show = true
        },
        cancel() {
            this.show = false
        },
        confirm() {
            this.$emit('myEvent', this.currentDate)
            this.show = false
        }
    },
    comments: {

    }
}
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #fff;
    overflow: hidden;
}
</style>